var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58125 3.58125 0 8 0C12.4188 0 16 3.58125 16 8C16 12.4188 12.4188 16 8 16C3.58125 16 0 12.4188 0 8ZM11.4375 8.57031C11.7484 8.57031 12 8.31875 12 8.00781C12 7.69688 11.7484 7.44531 11.4375 7.44531H8.57031V4.57812C8.57031 4.26719 8.31875 4.01562 8.00781 4.01562C7.69688 4.01562 7.44531 4.26719 7.44531 4.57812V7.44531H4.5625C4.25156 7.44531 4 7.69688 4 8.00781C4 8.31875 4.25156 8.57031 4.5625 8.57031H7.44531V11.4219C7.44531 11.7328 7.69688 11.9844 8.00781 11.9844C8.31875 11.9844 8.57031 11.7328 8.57031 11.4219V8.57031H11.4375Z",
    fill: "#00ABC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.e63fcb50264e60ab72ce0dc540e7628a.svg";
export { ForwardRef as ReactComponent };